module.exports = ".modal-header{background-color:#303f9f;margin:-10px 0px 6px 0px;padding:1px;color:#fff}\n"